module.exports = __webpack_public_path__ + "img/5-1.6818be9a.png";